// packages/a11y/src/shared/filter-message.js
var previousMessage = "";
function filterMessage(message) {
  message = message.replace(/<[^<>]+>/g, " ");
  if (previousMessage === message) {
    message += "\xA0";
  }
  previousMessage = message;
  return message;
}
export {
  filterMessage as default
};
//# sourceMappingURL=filter-message.js.map
